var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate1Web = function SvgTemplate1Web(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.3333 5.33203H5.33333C4.59695 5.33203 4 5.92898 4 6.66536V11.9987C4 12.7351 4.59695 13.332 5.33333 13.332H13.3333C14.0697 13.332 14.6667 12.7351 14.6667 11.9987V6.66536C14.6667 5.92898 14.0697 5.33203 13.3333 5.33203Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6666 5.33203H18.6666C17.9302 5.33203 17.3333 5.92898 17.3333 6.66536V11.9987C17.3333 12.7351 17.9302 13.332 18.6666 13.332H26.6666C27.403 13.332 27.9999 12.7351 27.9999 11.9987V6.66536C27.9999 5.92898 27.403 5.33203 26.6666 5.33203Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.3333 18.668H5.33333C4.59695 18.668 4 19.2649 4 20.0013V25.3346C4 26.071 4.59695 26.668 5.33333 26.668H13.3333C14.0697 26.668 14.6667 26.071 14.6667 25.3346V20.0013C14.6667 19.2649 14.0697 18.668 13.3333 18.668Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6666 18.668H18.6666C17.9302 18.668 17.3333 19.2649 17.3333 20.0013V25.3346C17.3333 26.071 17.9302 26.668 18.6666 26.668H26.6666C27.403 26.668 27.9999 26.071 27.9999 25.3346V20.0013C27.9999 19.2649 27.403 18.668 26.6666 18.668Z",
    stroke: "currentColor"
  })));
};
export default SvgTemplate1Web;